import React, { useState, useEffect, useRef } from "react";
import YouthLogoDark from "../../../assets/images/youth_logo_dark.png";
import YouthLogoLight from "../../../assets/images/youth_logo_light.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formDataHelper, notify } from "../../../util/helpers";
import eyeopen from "../../../assets/icons/eye-open.svg";
import eyeclose from "../../../assets/icons/EyeClose.svg";
import {
  checkAccountExistsLogic,
  registerCaregiverLogic,
} from "../../../store/features/app/appSlice";
import { Helmet } from "react-helmet";
import { isEmptyObject } from "jquery";

const NewUserComponent = ({ setPreviousData, setUserType, userType }) => {
  const passwordField = useRef();
  const passwordIcon = useRef();
  const navigate = useNavigate();
  const { loading, user } = useSelector((state) => state.app);
  const originURL = window.location.origin;
  useEffect(() => {
    if (user) {
      if (user?.role !== "CAREGIVER" || !originURL.includes("youth")) {
        if (originURL !== "http://localhost:3000") {
          navigate("/dashboard/home/");
        }
      }
    }
  }, []);

  const toggleVisibility = () => {
    if (passwordField.current.type === "password") {
      passwordField.current.type = "text";
      passwordIcon.current.src = eyeclose;
    } else {
      passwordField.current.type = "password";
      passwordIcon.current.src = eyeopen;
    }
  };

  const handleSubmit = (form) => {
    const validateData = (data) => {
      Object.values(data).forEach((value) => {
        if (value.length === 0) {
          return false;
        }
      });
      return true;
    };

    form.preventDefault();
    let formData = new FormData(form.target);
    const data = formDataHelper(formData);
    if (validateData(data)) {
      setPreviousData(data);
      setUserType("step-2");
    } else {
      notify("Enter valid data!", "error");
    }
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="container"
      style={{ display: userType === "new" ? "block" : "none" }}
    >
      <div className="container-fluid">
        <h2 className="primary-text-blue">Create Account</h2>
      </div>
      <div className="container mt-5">
        <div className="form-group py-2">
          <label>
            <strong>First Name</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter first name"
            name="first_name"
            id="first_name"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Last Name</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter Last name"
            name="last_name"
            id="last_name"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Contact</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter contact number"
            type="tel"
            name="contact"
            id="contact"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Email</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter email"
            name="email"
            id="email"
          />
        </div>
        <div className="form-group py-2">
          <label>
            {" "}
            <strong>Your Password</strong>
          </label>
          <div style={{ position: "relative" }}>
            <input
              required={true}
              style={{ marginTop: "6px" }}
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your Password"
              ref={passwordField}
            />
            <img
              src={eyeopen}
              ref={passwordIcon}
              onClick={toggleVisibility}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              alt="Show Password"
              height="25px"
              width="25px"
            />
          </div>
        </div>

        <br />
        <div className="container-fluid text-center py-4">
          <button
            type="submit"
            disabled={loading}
            className="primary-btn"
            style={{ width: "100%" }}
          >
            Enter Child Details {">"}
          </button>
        </div>
      </div>
    </form>
  );
};

const AdolescentDetails = ({ previousData, setUserType, userType }) => {
  const [childEmail, setChildEmail] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    checkAccountExistsLogic({ email: childEmail })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === false) {
            notify("This account doesn't seem to exist!", "info");
            return;
          }
          const data = { ...previousData };
          data["assessment_list"] = [26, 11]; //* Starting the patient off with some default assessments.
          data["patient_email"] = childEmail;
          dispatch(registerCaregiverLogic(data));
        }
      })
      .catch((e) => {
        notify("Something went wrong!", "error");
        notify("Please verify your data and try again!", "info");
        setUserType("new"); //Taking the user back to step-1 of registation with pre-filled data.
      })
      .catch((e) => {
        notify("This account doesn't seem to exist!", "error");
      });
  };
  const { loading } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  return (
    <div
      className="container"
      style={{ display: userType === "step-2" ? "block" : "none" }}
    >
      <div className="container-fluid">
        <h3 className="primary-text-blue">
          Enter Adolescent details to complete your registration
        </h3>
      </div>
      <form onSubmit={handleSubmit} className="container mt-5">
        <div className="form-group py-2">
          <label>
            <strong>Email address associated with their account</strong>
          </label>
          <input
            placeholder="Enter Email Address"
            name="patient_email"
            id="patient_email"
            style={{ marginTop: "6px" }}
            value={childEmail}
            onInput={(e) => {
              setChildEmail(e.target.value);
            }}
          />
        </div>
        <br />
        <div className="container-fluid text-center py-4">
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading}
            className="primary-btn"
            style={{ width: "100%" }}
          >
            Complete Sign Up
          </button>
          <br />
          <button
            className="primary-text-blue"
            style={{
              border: "none !important",
              outline: "none !important",
              cursor: "pointer",
              backgroundColor: "transparent",
              padding: "3%",
              marginTop: "10px",
            }}
            onClick={() => setUserType("new")}
          >
            {`<`} Go Back
          </button>
        </div>
      </form>
    </div>
  );
};

const LandingPage = () => {
  const [userType, setUserType] = useState(null);
  const [previousData, setPreviousData] = useState({});
  const { loading, user } = useSelector((state) => state.app);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isEmptyObject(user)) {
        navigate("/caregiver/assessments");
      }
    }
  }, [loading]);
  return (
    <section className="container-fluid w-100 m-0 p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Caregiver | Rose Health</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div className="container-fluid row">
        <div className="container-fluid col-sm-12 col-md-7 col-lg-7 caregiverBg">
          <img
            src={YouthLogoLight}
            style={{ height: "25%", marginTop: "40vh" }}
            alt="Caregiver Background Image"
          />
          <h1 className="text-white">
            Welcome to the ROSE Caregiver Platform!
          </h1>
        </div>
        <div
          className="container-fluid col-sm-12 col-md-5 col-lg-5"
          style={{ backgroundColor: "white" }}
        >
          <div className="container-fluid w-100 text-center py-4">
            <img
              src={YouthLogoDark}
              style={{ height: "25%", width: "25%" }}
              alt="Caregiver Background Image"
            />
          </div>
          {!userType && (
            <div className="container mt-5 text-center p-3">
              <h3>Welcome, you are a...</h3>
              <div
                className="container d-flex justify-content-center mt-4"
                style={{ gap: "20px" }}
              >
                <button
                  className="alternative-btn px-3"
                  onClick={() => {
                    navigate("/dashboard/home/");
                  }}
                >
                  Returning User
                </button>
                <button
                  className="primary-btn"
                  onClick={() => {
                    setUserType("new");
                  }}
                >
                  New User
                </button>
              </div>
            </div>
          )}

          <NewUserComponent
            setPreviousData={setPreviousData}
            setUserType={setUserType}
            userType={userType}
          />

          {userType === "step-2" && (
            <AdolescentDetails
              previousData={previousData}
              setUserType={setUserType}
              userType={userType}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
